import { memo, useCallback, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import { BetTicketContentFooter } from "../bet-ticket/bet-ticket-content-footer";
import { TicketConfig } from "../../../../../models/partnerResponse";
import { useStore, useTranslation } from "../../../../../hooks";
import { TicketAccepted } from "../../../../../models";
import { PrintTypes } from "../../../../../enums";
import { BetInfo } from "../ticket/bet-info";
import { T } from '../../../../../constants';
import { Ticket } from "../ticket";

interface JackpotTicketProps {
  data: TicketAccepted;
  ticketConfig: TicketConfig;
}

const JackpotTicket: React.FC<JackpotTicketProps> = observer(
  ({ data, ticketConfig }) => {
    const t = useTranslation();

    const {
      ticketsStore,
      partnerStore: { isPinRequiredForPayout },
    } = useStore();

    const {
      barcode,
      date,
      ticketId,
      betId,
      winAmount,
      betAmount,
      jackpotType,
      currencyCode,
    } = data;
    const [ticketLoaded, setTicketLoaded] = useState(false);
    const [imgImageError, setImgImageError] = useState<any>(false);

    useEffect(() => {
      if (ticketLoaded || imgImageError || ticketConfig?.logo === null) {
        if (isPinRequiredForPayout) {
          ticketsStore.printTicket(ticketId).then((res) => {
            window.print();
          });
        } else {
          window.print();
        }
      }
    }, [ticketLoaded, imgImageError, barcode]);

    const handleTicketLoad = useCallback(() => {
      setTicketLoaded(ticketConfig?.showLogo || true);
    }, []);

    return (
      <Ticket
        barcode={barcode}
        onTicketLoad={handleTicketLoad}
        showLogo={ticketConfig?.showLogo}
        logo={ticketConfig?.logo}
        setImgImageError={setImgImageError}
      >
          {/*win jackpot section*/}
          <div className="win-jackpot">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.53848 0.774398L10.0263 4.54087L13.7918 6.02905C13.9349 6.08419 14.065 6.1685 14.1737 6.27663C14.2825 6.38475 14.3676 6.51433 14.4237 6.65713C14.5311 6.93305 14.5249 7.24028 14.4065 7.51166C14.2881 7.78303 14.0671 7.99648 13.7918 8.10531L10.0263 9.59149L8.53848 13.36C8.4245 13.648 8.19853 13.876 7.91057 13.99C7.63497 14.0976 7.32803 14.0917 7.05677 13.9736C6.7855 13.8556 6.57196 13.635 6.46277 13.36L4.97497 9.59149L1.20949 8.10531C1.00047 8.02386 0.820915 7.88117 0.694323 7.69594C0.567729 7.51071 0.499999 7.29156 0.499999 7.06718C0.499999 6.8428 0.567729 6.62365 0.694323 6.43842C0.820915 6.25319 1.00047 6.11051 1.20949 6.02905L4.97497 4.54087L6.46277 0.774398C6.5179 0.630931 6.60242 0.500584 6.7109 0.391729C6.81938 0.282874 6.94943 0.197919 7.09268 0.14232C7.36829 0.0354982 7.67494 0.0419992 7.94578 0.160404C8.21661 0.278808 8.42966 0.499512 8.53848 0.774398Z" fill="black"/>
              </svg>
              <p className="win-jackpot-title">{t(T.CONGRATULATIONS)} <br/>{t(T.YOU_WON_JACKPOT)}</p>
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.53848 0.774398L10.0263 4.54087L13.7918 6.02905C13.9349 6.08419 14.065 6.1685 14.1737 6.27663C14.2825 6.38475 14.3676 6.51433 14.4237 6.65713C14.5311 6.93305 14.5249 7.24028 14.4065 7.51166C14.2881 7.78303 14.0671 7.99648 13.7918 8.10531L10.0263 9.59149L8.53848 13.36C8.4245 13.648 8.19853 13.876 7.91057 13.99C7.63497 14.0976 7.32803 14.0917 7.05677 13.9736C6.7855 13.8556 6.57196 13.635 6.46277 13.36L4.97497 9.59149L1.20949 8.10531C1.00047 8.02386 0.820915 7.88117 0.694323 7.69594C0.567729 7.51071 0.499999 7.29156 0.499999 7.06718C0.499999 6.8428 0.567729 6.62365 0.694323 6.43842C0.820915 6.25319 1.00047 6.11051 1.20949 6.02905L4.97497 4.54087L6.46277 0.774398C6.5179 0.630931 6.60242 0.500584 6.7109 0.391729C6.81938 0.282874 6.94943 0.197919 7.09268 0.14232C7.36829 0.0354982 7.67494 0.0419992 7.94578 0.160404C8.21661 0.278808 8.42966 0.499512 8.53848 0.774398Z" fill="black"/>
              </svg>

          </div>
        <BetInfo date={date} ticketId={ticketId} />

        <BetTicketContentFooter
          betId={betId}
          currencyCode={currencyCode || ""}
          ticketType={PrintTypes.Jackpot}
          winAmount={winAmount}
          betAmount={betAmount}
          jackpotType={jackpotType}
        />
      </Ticket>
    );
  },
);

export default memo(JackpotTicket);
